import { gql } from 'apollo-angular';

export const SIGN_UP = gql`
  mutation AccountRegister($input: MarketplaceAccountRegisterInput!) {
    accountRegister(input: $input) {
      user {
        firstName
        lastName
        isStaff
        isActive
        isConfirmed
        email
      }
      errors {
        field
        message
        code
        addressType
      }
    }
  }
`;

export const SIGN_IN = gql`
  mutation TokenCreate($email: String!, $password: String!) {
    tokenCreate(email: $email, password: $password) {
      token
      refreshToken
      errors {
        field
        message
      }
    }
  }
`;

export const CONFIRM_ACCOUNT = gql`
  mutation ConfirmAccount($email: String!, $token: String!) {
    confirmAccount(email: $email, token: $token) {
      errors {
        field
        code
      }
      user {
        email
        isActive
        isConfirmed
      }
    }
  }
`;

export const GOOGLE_REGISTER = gql`
  mutation AccountRegister($input: MarketplaceAccountRegisterInput!) {
    accountRegister(input: $input) {
      user {
        email
        isConfirmed
        isActive
      }
      errors {
        message
        field
        code
        addressType
      }
    }
  }
`;

export const GOOGLE_SIGN_IN = gql`
  mutation TokenCreate($idToken: String) {
    tokenCreate(idToken: $idToken) {
      token
      refreshToken
      errors {
        message
        code
      }
      user {
        id
        email
      }
    }
  }
`;
export const DELETE_ACCOUNT = gql`
  mutation AccountDelete($token: String!) {
    accountDelete(token: $token) {
      errors {
        addressType
        code
        field
        message
      }
    }
  }
`;

export const REQUEST_DELETION_ACCOUNT = gql`
  mutation AccountRequestDeletion($redirectUrl: String!) {
    accountRequestDeletion(redirectUrl: $redirectUrl, channel: "zammy-ko") {
      errors {
        addressType
        code
        field
        message
      }
    }
  }
`;
